import React from 'react'
import {colors} from '../../../../colors'
import {SharedIconProps} from '../Icon'

export const IconTip = (props: SharedIconProps) => {
  const fill = props.fill || colors.brand.purple

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" {...props} fill="none">
      <path
        d="M9 19h6M10 22h4M12 6a6 6 0 0 0-3.72 10.71c.82.66 1.22 1.49 1.22 2.29h5c0-.8.4-1.63 1.22-2.29A6 6 0 0 0 12 6Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 1v2M4.22 4.22l1.42 1.42M18.36 5.64l1.42-1.42M1 12h2M21 12h2"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
